import { PlatformModule } from "@angular/cdk/platform";
import { CommonModule, TitleCasePipe } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { EdpAvatarComponent } from "@edp-components/edp-avatar";
import { EdpBreadcrumbComponent } from "@edp-components/edp-breadcrumb";
// ------ Dashboard Widgets ------
import {
    EdpContractConsumptionsComponent,
    EdpContractConsumptionsGasComponent,
    EdpWidgetConsumptionsSupportComponent
} from "@edp-components/edp-card-widgets/edp-widget-consumptions";
import { EdpContractComponent } from "@edp-components/edp-contract";
import { EdpContractThirdPartyComponent } from "@edp-components/edp-contract-third-party/edp-contract-third-party.component";
import { EdpDiscountFormComponent } from "@edp-components/edp-discount-form";
import { EdpHeaderComponent } from "@edp-components/edp-header";
import { EdpModalAlertComponent, EdpModalComponent, EdpModalConfirmComponent, EdpModalStatusComponent } from "@edp-components/edp-modal";
import { EdpMouseEventComponent } from "@edp-components/edp-mouse-event/edp-mouse-event.component";
import { EdpPackComponent } from "@edp-components/edp-pack";
import { EdpPackContaCertaModalComponent } from "@edp-components/edp-pack-conta-certa-modal";
import { EdpPackDiscountComponent } from "@edp-components/edp-pack-discount";
import { EdpPackHealthModalComponent } from "@edp-components/edp-pack-health-modal";
import { EdpSubmenuComponent } from "@edp-components/edp-submenu/edp-submenu.component";
import { EdpTableComponent } from "@edp-components/edp-table/edp-table.component";
import { CollapseModule } from "@edp-directives/collapse";
import { ExternalLinkModule } from "@edp-directives/external-link/external-link.module";
import { HideOnModule } from "@edp-directives/hide-on/hide-on.module";
import { ImgFallbackModule } from "@edp-directives/img-fallback";
import { ImpersonateDisableModule } from "@edp-directives/impersonate-disable/impersonate-disable.module";
import { OperationHistoryModule } from "@edp-directives/operation-history/operation-history.module";
import { ScrollListItemModule } from "@edp-directives/scroll-list-item/scroll-list-item.module";
import { ConfigurationService } from "@edp-services/configuration.service";
import { ConsumptionsService } from "@edp-services/consumptions.service";
import { ContractService } from "@edp-services/contract.service";
import { DashboardService } from "@edp-services/dashboard.service";
import { PackSubscriberService } from "@edp-services/pack-subscriber.service";
import { UserService } from "@edp-services/user.service";
import {
    NgbAccordionModule,
    NgbAlertModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbPaginationModule,
    NgbPopoverModule
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
// ------END ------*/
import { AngularResizedEventModule } from "angular-resize-event";
import { UserIdleModule } from "angular-user-idle";
import { NgCircleProgressModule } from "ng-circle-progress";
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from "ng-recaptcha";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { CookieService } from "ngx-cookie-service";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { LottieModule } from "ngx-lottie";
import { EdpPipesModule } from "../@pipes/edp-pipes.module";
import { EdpCallbackComponent } from "./callback/callback.component";
import { EdpAlertComponent } from "./edp-alert/edp-alert.component";
import { EdpWidgetAdvantagesAndBenefitsComponent } from "./edp-card-widgets/edp-widget-advantages-and-benefits/edp-widget-advantages-and-benefits.component";
import { EdpWidgetBillingComponent } from "./edp-card-widgets/edp-widget-billing/edp-widget-billing.component";
import { EdpWidgetPaymentDirectDebitComponent } from "./edp-card-widgets/edp-widget-billing/edp-widget-payment-direct-debit/edp-widget-payment-direct-debit.component";
import { EdpPaymentMethodComponent } from "./edp-card-widgets/edp-widget-billing/edp-widget-payment/edp-payment-method/edp-payment-method.component";
import { EdpWidgetPaymentComponent } from "./edp-card-widgets/edp-widget-billing/edp-widget-payment/edp-widget-payment.component";
import { EdpChartComponent } from "./edp-card-widgets/edp-widget-chart-billing/edp-chart/edp-chart.component";
import { EdpWidgetChartBillingComponent } from "./edp-card-widgets/edp-widget-chart-billing/edp-widget-chart-billing.component";
import { EdpWidgetConsumptionsSimulationContaCertaComponent } from "./edp-card-widgets/edp-widget-consumptions/edp-widget-consumptions-simulation-conta-certa/edp-widget-consumptions-simulation-conta-certa.component";
import { EdpWidgetContaCertaComponent } from "./edp-card-widgets/edp-widget-conta-certa/edp-widget-conta-certa.component";
import { EdpWidgetFuncionaComponent } from "./edp-card-widgets/edp-widget-funciona/edp-widget-funciona.component";
import { EdpWidgetHealthComponent } from "./edp-card-widgets/edp-widget-health/edp-widget-health.component";
import { EdpWidgetMobilityComponent } from "./edp-card-widgets/edp-widget-mobility/edp-widget-mobility.component";
import { EdpWidgetPartnersComponent } from "./edp-card-widgets/edp-widget-partners/edp-widget-partners.component";
import { EdpWidgetPaymentDebtComponent } from "./edp-card-widgets/edp-widget-payment-debt/edp-widget-payment-debt.component";
import { EdpWidgetSavingsComponent } from "./edp-card-widgets/edp-widget-savings/edp-widget-savings.component";
import { EdpWidgetWithoutBillingComponent } from "./edp-card-widgets/edp-widget-without-billing/edp-widget-without-billing.component";
import { EdpWidgetWithoutPaymentComponent } from "./edp-card-widgets/edp-widget-without-billing/edp-widget-without-payment/edp-widget-without-payment.component";
import { EdpCardContractComponent } from "./edp-card/contract/edp-card-contract/edp-card-contract.component";
import { EdpCardPendingApprovalComponent } from "./edp-card/contract/edp-card-pending-approval/edp-card-pending-approval.component";
import { EdpContaCertaModalComponent } from "./edp-conta-certa-modal/edp-conta-certa-modal.component";
import { EdpContractListFilterContentComponent } from "./edp-contract-list/edp-contract-list-filter/edp-contract-list-filter-content/edp-contract-list-filter-content.component";
import { EdpContractListFilterComponent } from "./edp-contract-list/edp-contract-list-filter/edp-contract-list-filter.component";
import { EdpContractListComponent } from "./edp-contract-list/edp-contract-list.component";
import { EdpECodeGenerationModalComponent } from "./edp-e-code-generation-modal/edp-e-code-generation-modal.component";
import { EdpESubmitGiveawayModalComponent } from "./edp-e-submit-giveaway-modal/edp-e-submit-giveaway-modal.component";
import { EdpHeaderContractOfferComponent } from "./edp-header-contract/edp-header-contract-offer/edp-header-contract-offer.component";
import { EdpHeaderContractComponent } from "./edp-header-contract/edp-header-contract.component";
import { EdpHeaderPackComponent } from "./edp-header-contract/edp-header-pack/edp-header-pack.component";
import { EdpHeaderSavingsComponent } from "./edp-header-contract/edp-header-savings/edp-header-savings.component";
import { EdpIframeComponent } from "./edp-iframe/edp-iframe.component";
import { EdpLoaderModule } from "./edp-loader/edp-loader.module";
import { EdpMbwayPaymentsComponent } from "./edp-mbway-payments/edp-mbway-payments.component";
import { EdpOnboardingComponent } from "./edp-onboarding/edp-onboarding.component";
import { EdpOpenBankingModalComponent } from "./edp-open-banking-modal/edp-open-banking-modal.component";
import { EdpPopoverComponent } from "./edp-popover/edp-popover.component";
import { EdpRoundedModule } from "./edp-rounded-progress/edp-rounded-progress.module";
import { EdpSelectListModule } from "./edp-select-list/edp-select-list.module";
import { EdpSmsPaymentsComponent } from "./edp-sms-payments/edp-sms-payments.component";
import { EdpToasterModule } from "./edp-toaster/edp-toaster.module";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { EdpRedyCardBarComponent } from "./edp-redy-card-bar/edp-redy-card-bar.component";
import { EdpBreadcrumbMobileComponent } from "./edp-breadcrumb-mobile/edp-breadcrumb-mobile.component";
import { EdpPaymentUserFeedbackModalComponent } from "./edp-payment-user-feedback-modal/edp-payment-user-feedback-modal.component";
import { EdpWidgetSmartNowComponent } from "./edp-card-widgets/edp-widget-smart-now/edp-widget-smart-now.component";
import { EdpECodeGenerationMultiCodesComponent } from "./edp-e-code-generation-modal/code-generation-multi-codes/code-generation-multi-codes.component";
import { EdpTableV2Component } from "./edp-table-v2/edp-table-v2.component";
import { EdpWidgetConsumptionsJumbotronModule } from "./edp-card-widgets/edp-widget-consumptions/edp-widget-consumptions-jumbotron/edp-widget-consumptions-jumbotron.module";
import { EdpContractConsumptionsElectricityModule } from "./edp-card-widgets/edp-widget-consumptions/edp-widget-consumptions-electricity/edp-widget-consumptions-electricity.module";
import { EdpWidgetConsumptionsVoiceReadingModule } from "./edp-card-widgets/edp-widget-consumptions/edp-widget-consumptions-voice-reading/edp-widget-consumptions-voice-reading.module";
import { EdpSmartnowDashboardWidgetComponent } from "./edp-smartnow-dashboard-widget/edp-smartnow-dashboard-widget.component";
import { EdpSmartnowNextBillingWidgetComponent } from "./edp-smartnow-next-billing-widget/edp-smartnow-next-billing-widget.component";
import { EdpWidgetRequestsComponent } from "./edp-card-widgets/edp-widget-requests/edp-widget-requests.component";
import { EdpRangeComponent } from "./edp-range/components/edp-range.component";
import { EdpEMacroFinishedModalComponent } from "./edp-e-macro-finished-modal/edp-e-macro-finished-modal.component";
import { EdpEConsentModalComponent } from "./edp-e-consent-modal/edp-e-consent-modal.component";
import { EdpContractLocalCardComponent } from "./edp-contract-list/edp-contract-local-card/edp-contract-local-card.component";
import { EdpERaceChallengeCompleteModalModule } from "./edp-e-race-challenge-complete-modal/edp-e-race-challenge-complete-modal.module";
import { EdpWidgetCounterSavingsComponent } from "./edp-card-widgets/edp-widget-counter-savings/edp-widget-counter-savings.component";
import { EdpSelectSearchableModule } from "./edp-select-searchable/edp-select-searchable.module";
import { EdpEMoreGreenChoicesModalComponent } from "./edp-e-more-green-choices-modal/edp-e-more-green-choices-modal.component";
import { EdpFilterPickerModule } from "./edp-filter-picker/edp-filter-picker.module";
import { EdpUnavailabilityModule } from "./edp-unavailability/edp-unavailability.module";
import { EdpSimulationTooltipComponent } from "./edp-card-widgets/edp-widget-consumptions/edp-simulation-tooltip/edp-simulation-tooltip.component";
import { EdpWidgetConsumptionsSimulationComponent } from "./edp-card-widgets/edp-widget-consumptions/edp-widget-consumptions-simulation/edp-widget-consumptions-simulation.component";
import { EdpModalConfirmChangesComponent } from "./edp-modal/confirm-changes/edp-modal-confirm-changes.component";
import { ConditionalRegionModule } from "@edp-directives/conditional-region/conditional-region.module";
// ------ ES ------*/
import { EdpEsContractListComponent } from "./ES/edp-es-contract-list/edp-es-contract-list.component";
import { EdpEsContractLocalCardComponent } from "./ES/edp-es-contract-list/edp-es-contract-local-card/edp-es-contract-local-card.component";
import { EdpContractListWelcomeComponent } from "./ES/edp-es-contract-list/edp-contract-list-welcome/edp-contract-list-welcome.component";
import { EdpContactModalComponent } from "./ES/edp-contact-modal/edp-contact-modal.component";
import { EdpDetailModalComponent } from "./ES/edp-detail-modal/edp-detail-modal.component";

// ------ ES END ------*/
import { EdpStepsProgressModule } from "./edp-steps-progress/edp-steps-progress.module";
import { EdpSideStepsModule } from "./edp-side-steps/edp-side-steps.module";
import { EdpProgressBarModule } from "./edp-progress-bar/edp-progress-bar.module";
import { GaEventModule } from "@edp-directives/datalayer/gaevent/gaevent.module";
import { GaClickModule } from "@edp-directives/datalayer/gaclick/gaclick.module";
import { EdpTooltipModule } from "./edp-tooltip/edp-tooltip.module";
import { EdpDefineHouseTermsConditionsComponent } from "./edp-define-house-terms-conditions/edp-define-house-terms-conditions.component";
import { NoSpecialCharactersModule } from "@edp-directives/no-special-characters/no-special.characters.module";

const globalSettings: RecaptchaSettings = { siteKey: "6LcAKUIUAAAAADYV2YPpzCE0NQ9R7L44DneoyWc8" };
export function playerFactory() {
    return import("lottie-web");
}
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        CollapseModule,
        NgbDropdownModule,
        NgbPopoverModule,
        NgbPaginationModule,
        NgbAccordionModule,
        NgbAlertModule,
        NgbCollapseModule,
        NgbNavModule,
        ImgFallbackModule,
        BsDatepickerModule.forRoot(),
        InfiniteScrollModule,
        OperationHistoryModule,
        ExternalLinkModule,
        EdpToasterModule,
        UserIdleModule.forRoot({ idle: 5, timeout: 5, ping: 1 }),
        AngularResizedEventModule,
        EdpPipesModule,
        NgCircleProgressModule.forRoot({}),
        RecaptchaModule,
        ScrollListItemModule,
        LottieModule.forRoot({ player: playerFactory }),
        ImpersonateDisableModule,
        EdpLoaderModule,
        EdpRoundedModule,
        EdpSelectListModule,
        SlickCarouselModule,
        EdpWidgetConsumptionsJumbotronModule,
        EdpContractConsumptionsElectricityModule,
        EdpWidgetConsumptionsVoiceReadingModule,
        PlatformModule,
        EdpSelectSearchableModule,
        EdpFilterPickerModule,
        EdpUnavailabilityModule,
        ConditionalRegionModule,
        EdpStepsProgressModule,
        EdpSideStepsModule,
        EdpProgressBarModule,
        GaClickModule,
        GaEventModule,
        EdpTooltipModule,
        NoSpecialCharactersModule
    ],
    declarations: [
        EdpHeaderComponent,
        EdpBreadcrumbComponent,
        EdpAvatarComponent,
        EdpSubmenuComponent,
        EdpContractComponent,
        EdpModalComponent,
        EdpModalConfirmComponent,
        EdpModalAlertComponent,
        EdpModalConfirmChangesComponent,
        EdpPackComponent,
        EdpPackDiscountComponent,
        EdpDiscountFormComponent,
        EdpPackHealthModalComponent,
        EdpTableComponent,
        EdpModalStatusComponent,
        EdpPackContaCertaModalComponent,
        EdpMouseEventComponent,
        EdpCardContractComponent,
        EdpContractListComponent,
        EdpContractListFilterComponent,
        EdpContractListFilterContentComponent,
        EdpCardPendingApprovalComponent,
        EdpContractThirdPartyComponent,
        EdpEMacroFinishedModalComponent,
        // ------ Dashboard Widgets ------
        EdpContractConsumptionsComponent,
        EdpContractConsumptionsGasComponent,
        EdpWidgetConsumptionsSupportComponent,
        EdpWidgetChartBillingComponent,
        EdpWidgetHealthComponent,
        EdpWidgetAdvantagesAndBenefitsComponent,
        EdpWidgetSavingsComponent,
        EdpWidgetCounterSavingsComponent,
        EdpWidgetSmartNowComponent,
        EdpWidgetPartnersComponent,
        EdpWidgetHealthComponent,
        EdpWidgetRequestsComponent,
        EdpWidgetBillingComponent,
        EdpPaymentMethodComponent,
        EdpWidgetPaymentComponent,
        EdpWidgetPaymentDirectDebitComponent,
        EdpWidgetPaymentDebtComponent,
        EdpWidgetFuncionaComponent,
        EdpSmsPaymentsComponent,
        EdpWidgetContaCertaComponent,
        EdpWidgetWithoutBillingComponent,
        EdpWidgetWithoutPaymentComponent,
        EdpWidgetConsumptionsSimulationContaCertaComponent,
        EdpSmartnowDashboardWidgetComponent,
        EdpSmartnowNextBillingWidgetComponent,
        EdpWidgetMobilityComponent,
        EdpWidgetConsumptionsSimulationComponent,
        EdpSimulationTooltipComponent,
        // ------ END ------*/
        EdpContaCertaModalComponent,
        EdpChartComponent,
        EdpPopoverComponent,
        EdpMbwayPaymentsComponent,
        EdpOpenBankingModalComponent,
        EdpPaymentUserFeedbackModalComponent,
        EdpCallbackComponent,
        EdpIframeComponent,
        EdpHeaderContractComponent,
        EdpHeaderContractOfferComponent,
        EdpHeaderPackComponent,
        EdpHeaderSavingsComponent,
        EdpOnboardingComponent,
        EdpECodeGenerationModalComponent,
        EdpESubmitGiveawayModalComponent,
        EdpAlertComponent,
        EdpRedyCardBarComponent,
        EdpBreadcrumbMobileComponent,
        EdpECodeGenerationMultiCodesComponent,
        EdpTableV2Component,
        EdpSmartnowNextBillingWidgetComponent,
        EdpRangeComponent,
        EdpEConsentModalComponent,
        EdpContractLocalCardComponent,
        EdpEMoreGreenChoicesModalComponent,
        EdpDefineHouseTermsConditionsComponent,
        // ------ ES ------*/
        EdpContractListWelcomeComponent,
        EdpEsContractListComponent,
        EdpEsContractLocalCardComponent,
        EdpContactModalComponent,
        EdpDetailModalComponent,
        // ------ END ES ------*/
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        CollapseModule,
        NgbDropdownModule,
        NgbPopoverModule,
        NgbAlertModule,
        NgbCollapseModule,
        NgbNavModule,
        BsDatepickerModule,
        EdpHeaderComponent,
        EdpBreadcrumbComponent,
        EdpAvatarComponent,
        EdpSubmenuComponent,
        EdpContractComponent,
        EdpPackComponent,
        EdpPackDiscountComponent,
        EdpDiscountFormComponent,
        EdpPackHealthModalComponent,
        EdpTableComponent,
        EdpPackContaCertaModalComponent,
        EdpModalComponent,
        EdpModalConfirmComponent,
        EdpModalStatusComponent,
        EdpEMacroFinishedModalComponent,
        InfiniteScrollModule,
        HideOnModule,
        OperationHistoryModule,
        ExternalLinkModule,
        EdpContractListComponent,
        // ------ Dashboard Widgets ------
        EdpContractConsumptionsComponent,
        EdpWidgetChartBillingComponent,
        EdpWidgetHealthComponent,
        EdpWidgetAdvantagesAndBenefitsComponent,
        EdpWidgetSavingsComponent,
        EdpWidgetCounterSavingsComponent,
        EdpWidgetSmartNowComponent,
        EdpWidgetPartnersComponent,
        EdpWidgetRequestsComponent,
        EdpWidgetBillingComponent,
        EdpWidgetPaymentDebtComponent,
        EdpWidgetFuncionaComponent,
        EdpWidgetWithoutBillingComponent,
        EdpSmartnowDashboardWidgetComponent,
        EdpSmartnowNextBillingWidgetComponent,
        EdpWidgetMobilityComponent,
        EdpWidgetConsumptionsSimulationComponent,
        EdpSimulationTooltipComponent,
        // ------ END ------*/
        RecaptchaModule,
        EdpHeaderContractComponent,
        LottieModule,
        EdpOnboardingComponent,
        EdpIframeComponent,
        ImpersonateDisableModule,
        EdpECodeGenerationModalComponent,
        EdpLoaderModule,
        EdpRoundedModule,
        EdpSelectListModule,
        EdpAlertComponent,
        EdpTableV2Component,
        EdpPopoverComponent,
        EdpRangeComponent,
        EdpEConsentModalComponent,
        EdpERaceChallengeCompleteModalModule,
        EdpSelectSearchableModule,
        EdpEMoreGreenChoicesModalComponent,
        EdpFilterPickerModule,
        EdpUnavailabilityModule,
        EdpSideStepsModule,
        EdpStepsProgressModule,
        EdpProgressBarModule,
        EdpDefineHouseTermsConditionsComponent,
        NoSpecialCharactersModule

    ],
    entryComponents: [
        EdpModalComponent,
        EdpModalConfirmComponent,
        EdpModalAlertComponent,
        EdpModalConfirmChangesComponent,
        EdpPackHealthModalComponent,
        EdpModalStatusComponent,
        EdpPackContaCertaModalComponent,
        EdpContractListComponent,
        EdpContractThirdPartyComponent,
        EdpSmsPaymentsComponent,
        EdpContaCertaModalComponent,
        EdpMbwayPaymentsComponent,
        EdpOpenBankingModalComponent,
        EdpIframeComponent,
        EdpWidgetConsumptionsSupportComponent,
        EdpContactModalComponent,
        EdpDetailModalComponent,
    ],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                ContractService,
                CookieService,
                PackSubscriberService,
                TitleCasePipe,
                ConfigurationService,
                DashboardService,
                ConsumptionsService,
                UserService,
                {
                    provide: RECAPTCHA_SETTINGS,
                    useValue: globalSettings,
                },
            ],
        };
    }
}
